module.exports = __webpack_public_path__ + "static/media/fotografias@2x.d461ae3d.jpg";